export enum RetailReportType {
  Enrollments = 'Enrollments',
  Attritions = 'Attritions',
  RetailStatistics = 'RetailStatistics',
}
